/**
 * Centralized button labels for the application
 * Ensures consistency across all components
 */

export const BUTTON_LABELS = {
  QUERY_IMDB: 'View on IMDb',
  WATCH_TRAILER: 'Watch trailer',
  NO_DETAILS_AVAILABLE: 'No details available',
};
